<template>
  <h3 v-if="selectedCategoryName && state.faqs.length > 0" class="cxco-o-faq__title">{{selectedCategoryName}}</h3>
  <section
    class="cxco-c-fold"
    :aria-labelledby="selectedCategoryName"
    :min-width="state.width"
    v-if="state.faqs.length > 0"
  >
    <article
      v-for="(faq, index) in state.faqs"
      class="cxco-c-fold__item"
      v-bind:key="faq.id"
      :data-state="faq.isSelected ? 'open' : 'closed'"
      v-scrollInView="index"
    >
      <button 
        @click="handleFaqClick(faq)" 
        class="cxco-c-fold__button"
        :aria-expanded="faq.isSelected"
        :aria-controls="`faq-content-${faq.id}`"
        :aria-busy="faq.isLoading"
      >
        <header class="cxco-c-fold__header">
          <h4 class="cxco-c-fold__title" :id="`faq-question-${faq.id}`">
            {{ faq.question }}
          </h4>
          <Icon 
            class="cxco-c-fold__icon" 
            :name="'toggle'" 
            aria-hidden="true"
          />
        </header>
      </button>
      <section 
        class="cxco-c-fold__content" 
        :aria-hidden="!faq.isSelected"
        :style="faq.isSelected ? '' : 'display:none'"
        :id="`faq-content-${faq.id}`"
        :aria-labelledby="`faq-question-${faq.id}`"
        v-content="faq.isSelected"
      >
        <article class="cxco-c-fold__article" v-html="faq.answer"></article>
        <Feedback :faq="faq" />
      </section>
    </article>
  </section>
</template>
<script>
import { inject } from "vue";
import { scrollInView, toggleFaq, getCategoryById } from "../utils";
import Feedback from "./feedback";
import Icon from "./icon";

export default {
  components: { Feedback, Icon },
  setup() {
    const state = inject("state");
    const actions = inject("actions");
    return { state, actions };
  },
  computed: {
    selectedCategoryName() {
      const selectedCategoryList = this.state.selectedCategories.filter(
        (id) => id !== -1
      );
      const selectedCatId = selectedCategoryList.find(
        (id, index, arr) => index === arr.length - 1
      );
      const category = getCategoryById(selectedCatId, this.state.categories);
      return category?.name || "";
    }
  },
  methods: {
    handleFaqClick(faq) {
      faq.isLoading = true
      
      let originalFaq 
      if(!faq.answer)
      {
        originalFaq = {...faq}
        faq.answer = 'Loading answer...'
      }

      // Fetch the new answer
      this.actions.getFaqAnswer(originalFaq || faq)

      faq.isLoading = false
    }
  },
  directives: {
    content: {
      updated(elm, binding) {
        if (binding.oldValue !== binding.value) {
          toggleFaq(elm);
        }
      },
    },
    scrollInView: {
      mounted(elm, binding) {
        if (binding.value === 0) {
          scrollInView(elm, {
            behavior: "smooth",
            block: "center"
          });
        }
      },
    },
  },
};
</script>
